/**
 *  @class
 *  @function CollectionLinks
 */

if (!customElements.get('collection-links')) {
  class CollectionLinks extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      setTimeout(() => {
        this.target = this.dataset.target;
        this.buttons = Array.from(this.querySelectorAll('button'));
        this.buttons.forEach((button, i) => {
          button.addEventListener('click', (event) => {
            let handle = button.dataset.collection;
            [].forEach.call(this.buttons, function (el) {
              el.classList.remove('active');
            });

            button.classList.add('active');

            if (handle) {
              this.toggleCollection(handle);
            }

            event.preventDefault();
          });
        });
      }, 20);
      if (Shopify.designMode) {
        this.addEventListener('shopify:block:select', (event) => {
          let index = this.buttons.indexOf(event.target);

          this.buttons[index].dispatchEvent(new Event('click'));
        });
      }
    }
    toggleCollection(handle) {
      let slider = document.getElementById(this.target),
        columns = slider.querySelectorAll(`.columns:not([data-collection*="${handle}"])`),
        active_columns = slider.querySelectorAll(`[data-collection*="${handle}"]`),
        flkty = new Flickity.data(slider, {
          draggable: false,
          cellSelector: '.image-cell',
        });
      [].forEach.call(columns, function (el) {
        el.classList.remove('carousel__slide');
        slider.append(el);
        lazyLoad: true;
      });
      [].forEach.call(active_columns, function (el) {
        if (el.dataset.collection === handle) {
          el.classList.add('carousel__slide');
        } else {
          el.classList.remove('carousel__slide');
          slider.append(el);
        }
      });
      flkty.insert(active_columns);
      flkty.reloadCells();
      flkty.select(0, 0, 1);
      flkty.unbindDrag();
    }
  }
  customElements.define('collection-links', CollectionLinks);
}
